import config from '../config'
import http from '../http'

export default{
    

    // 翻译文本接口
    translation:async function(payload) {
        const res = await http({
                url: config.TRANSLATION,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },

    getTokenUrl:async function(payload) {
        const res = await http({
                url: config.GET_AUTHORIZATION_URL,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },

    getShopConversationList:async function(payload) {
        const res = await http({
                url: config.GET_RECENT_MESSAGE_LIST,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    
    getConversationHistory:async function(payload) {
        const res = await http({
                url: config.GET_MESSAGE_HISTORY,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    uploadImage:async function(payload) {
        const res = await http({
                url: config.UPLOAD_IMAGE,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    sendMessage:async function(payload) {
        const res = await http({
                url: config.SEND_MESSAGE,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },

    getAuthorizedShopList:async function(payload) {
        const res = await http({
                url: config.GET_AUTHORIZED_SHOPS,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    pinned:async function(payload) {
        const res = await http({
                url: config.PINNED,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    readConversation:async function(payload) {
        const res = await http({
                url: config.READ_CONVERSATION,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    unreadCount:async function(payload) {
        const res = await http({
                url: config.GET_UNREAD_CONVERSATION,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    deleteConversation:async function(payload) {
        const res = await http({
                url: config.DELETE_CONVERSATION,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    getShortcutGroup:async function(payload) {
        const res = await http({
                url: config.GET_SHORTCUT_LIST_GROUP,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    getShortcutMessage:async function(payload) {
        const res = await http({
                url: config.GET_SHORTCUT_LIST_MESSAGE,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    searchMessage:async function(payload) {
        const res = await http({
                url: config.SEARCH_MESSAGE,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    getBuyerOrder:async function(payload) {
        const res = await http({
                url: config.GET_BUYER_ORDER,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    getAddShortCutMessage:async function(payload) {
        const res = await http({
                url: config.ADD_SHORTCUT_MESSAGE,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    getConversationAllHistory:async function(payload) {
        const res = await http({
                url: config.GET_CONSERVATION_ALL_HISTORY,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    addGroup:async function(payload) {
        const res = await http({
                url: config.ADD_SHORTCUT_GROUP,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },

    deleteShorcutGroup:async function(payload) {
        const res = await http({
                url: config.DELETE_SHORTCUT_GROUP,
                method: 'delete',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    deleteShorcutMessage:async function(payload) {
        const res = await http({
                url: config.DELETE_SHORTCUT_MESSAGE,
                method: 'delete',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    updateShortcutMessage:async function(payload) {
        const res = await http({
                url: config.UPDATE_SHORTCUT_MESSAGE,
                method: 'put',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    updateShortcutGroup:async function(payload) {
        const res = await http({
                url: config.UPDATE_SHORTCUT_GROUP,
                method: 'put',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    insertMessage:async function(payload) {
        const res = await http({
                url: config.SEND_MESSAGE,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    cancelorder:async function(payload) {
        const res = await http({
                url: config.CANCEL_ORDE,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//取消订单
    addremark:async function(payload) {
        const res = await http({
                url: config.ADD_REMARK,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//添加备注
    gettree:async function(payload) {
        const res = await http({
                url: config.GET_TREE,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },//获取目录树
    addtree:async function(payload) {
        const res = await http({
                url: config.ADD_TREE,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//添加目录树
    addknowledge:async function(payload) {
        const res = await http({
                url: config.ADD_KNOWLEDGE,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },//添加问答
    getknowledge:async function(payload) {
        const res = await http({
                url: config.GET_KNOWLEDGE,
                method: 'get',
                data:{
                    ...payload
                }
            })
        return res.data
    },//获取某个目录下的所有知识
    delknowledge:async function(payload) {
        const res = await http({
                url: config.DEL_KNOWLEDGE,
                method: 'delete',
                data:{
                    ...payload
                }
            })
        return res.data
    },//删除某个知识
    updateknowledge:async function(payload) {
        const res = await http({
                url: config.UPDATE_KNOWLEDGE,
                method: 'put',
                data:{
                     ...payload
                },
                
                
            })
        return res.data
    },//修改某个知识
    searchknowledge:async function(payload) {
        const res = await http({
                url: config.SEARCH_KNOWLEDGE,
                method: 'get',
                data:{
                    ...payload
                }
                
               
            })
        return res.data
    },//搜索某个知识
    getbuyeran:async function(payload) {
        const res = await http({
                url: config.GET_BUYER_ANALYSIS,
                method: 'get',
                data:{
                    ...payload
                }
                
               
            })
        return res.data
    },//获取买家画像
    matchknowledge:async function(payload) {
        const res = await http({
                url: config.MATCH_KNOWLEDGE,
                method: 'get',
                data:{
                    ...payload
                }
                
               
            })
        return res.data
    },//搜索命中的问题

    getqestion:async function(payload) {
        const res = await http({
                url: config.GET_QUESTION,
                method: 'get',
                data:{
                    ...payload
                }
                
               
            })
        return res.data
    },//获取推荐的问题
    frequqestion:async function(payload) {
        const res = await http({
                url: config.FREQUENT_QUESTION,
                method: 'get',
                data:{
                    ...payload
                }
                
               
            })
        return res.data
    },//获取高频的问题

    createconver:async function(payload) {
        const res = await http({
                url: config.CREATE_CONVER,
                method: 'post',
                data:{
                    ...payload
                }
                
               
            })
        return res.data
    },//创建会话
    messageinsert:async function(payload) {
        const res = await http({
                url: config.MESSAGE_INSERT,
                method: 'post',
                data:{
                    ...payload
                }
                
               
            })
        return res.data
    },//发送一条消息

    getmessage:async function(payload) {
        const res = await http({
                url: config.MESSAGE_CONVER,
                method: 'get',
                data:{
                    ...payload
                }
                
               
            })
        return res.data
    },//获取会话的历史消息

    converlist:async function(payload) {
        const res = await http({
                url: config.CONVER_LIST,
                method: 'get',
                data:{
                    ...payload
                }
                
               
            })
        return res.data
    },//获取会话的历史消息

    markread:async function(payload) {
        const res = await http({
                url: config.MARK_READ,
                method: 'post',
                data:{
                    ...payload
                }
                
               
            })
        return res.data
    },//标记会话为已读

    messasread:async function(payload) {
        const res = await http({
                url: config.MESSAGE_ASREAD,
                method: 'post',
                data:{
                    ...payload
                }
                
               
            })
        return res.data
    },//标记会话为已读

    deleteconver:async function(payload) {
        const res = await http({
                url: config.DELETE_CONVER,
                method: 'post',
                data:{
                    ...payload
                }
                
               
            })
        return res.data
    },//删除一个会话
}